import { useParams } from 'react-router-dom';
import { useCloseEditArteFinal, useGetEditArteFinal } from '../../../hooks/useArteFinal';
import EditFormArteFinalImprimible from './ArteFinalInfo/EditFormArteFinalImprimible';
import EditFormArteFinal from './ArteFinalInfo/EditFormArteFinal';
import EditFormArteFinalInformational from './ArteFinalInfo/EditFormArteFinalInformational';
import { useGetAllCenterTypes } from '../../../hooks/useCenterType';
import { Modal } from '@mui/material';

const EditArteFinal = () => {
  const { idArte } = useParams();
  const { data, isFetching } = useGetEditArteFinal(idArte);
  const { handleClose } = useCloseEditArteFinal();
  const { data: allCenterTypes } = useGetAllCenterTypes();

  if (isFetching) return null;

  const { arteFinal } = data.data;

  return (
    <Modal open onClose={handleClose}>
      <div className="create-arte-final-container-modal">
        {arteFinal.isInformational && (
          <EditFormArteFinalInformational data={data.data} allCenterTypes={allCenterTypes} onClose={handleClose} />
        )}
        {!arteFinal.isInformational && arteFinal.isDescargable && (
          <EditFormArteFinalImprimible data={data.data} allCenterTypes={allCenterTypes} onClose={handleClose} />
        )}
        {!arteFinal.isInformational && !arteFinal.isDescargable && (
          <EditFormArteFinal data={data.data} allCenterTypes={allCenterTypes} onClose={handleClose} />
        )}
      </div>
    </Modal>
  );
};

export default EditArteFinal;
